<template>
    <main-content with_go_back_bar>
        <kt-panel v-if="categoryDataStatus==='success'">
            <kt-panel-body >
                <form class="kt-form" @submit.prevent="editCat">
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="6" md="6" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="title">
                                        {{ $t('label.title') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="rtl"
                                        name="title"
                                        id="title"
                                        v-model="categoryData.title"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>

                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import {mapGetters} from "vuex";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {FAQService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";

export default {
    components: {
        MainContent
    },
    computed: {
        ...mapGetters('FAQ', [
            'categoryDataStatus',
            'categoryData'
        ])
    },
    methods: {
        editCat(e) {
            let btn = $('#submit_btn')
            let form = $(e.target)

            form.validate({
                ignore: ":hidden",
                rules: {
                    title: {
                        required: true
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            let params = {
                title : this.categoryData.title,
            }

            KTApp.progress(btn)
            //

        },
    },
    mounted() {
        //this.$store.dispatch('FAQ/fetchCategoryById', this.$route.params.hashid)
    }
}
</script>